var map = {
	"./biography-and-history.svg": 86809,
	"./biography-and-memoir.svg": 86944,
	"./career-and-success.svg": 53317,
	"./communication-and-social-skills.svg": 30896,
	"./corporate-culture.svg": 9692,
	"./creativity.svg": 15493,
	"./economics.svg": 40688,
	"./education.svg": 29682,
	"./entrepreneurship-and-small-business.svg": 54799,
	"./health-and-fitness.svg": 99815,
	"./management-and-leadership.svg": 2119,
	"./marketing-and-sales.svg": 87809,
	"./mindfulness-and-happiness.svg": 57471,
	"./money-and-investments.svg": 56213,
	"./motivation-and-inspiration.svg": 96407,
	"./nature-and-environment.svg": 19348,
	"./parenting.svg": 57631,
	"./personal-growth-and-self-improvement.svg": 73691,
	"./philosophy.svg": 9525,
	"./politics-and-society.svg": 17160,
	"./productivity-and-time-management.svg": 82762,
	"./psychology.svg": 11697,
	"./relationships-and-parenting.svg": 96622,
	"./religion-and-spirituality.svg": 7970,
	"./science.svg": 75407,
	"./society-and-culture.svg": 53960,
	"./technology-and-the-future.svg": 54843,
	"sprites/category/biography-and-history.svg": 86809,
	"sprites/category/biography-and-memoir.svg": 86944,
	"sprites/category/career-and-success.svg": 53317,
	"sprites/category/communication-and-social-skills.svg": 30896,
	"sprites/category/corporate-culture.svg": 9692,
	"sprites/category/creativity.svg": 15493,
	"sprites/category/economics.svg": 40688,
	"sprites/category/education.svg": 29682,
	"sprites/category/entrepreneurship-and-small-business.svg": 54799,
	"sprites/category/health-and-fitness.svg": 99815,
	"sprites/category/management-and-leadership.svg": 2119,
	"sprites/category/marketing-and-sales.svg": 87809,
	"sprites/category/mindfulness-and-happiness.svg": 57471,
	"sprites/category/money-and-investments.svg": 56213,
	"sprites/category/motivation-and-inspiration.svg": 96407,
	"sprites/category/nature-and-environment.svg": 19348,
	"sprites/category/parenting.svg": 57631,
	"sprites/category/personal-growth-and-self-improvement.svg": 73691,
	"sprites/category/philosophy.svg": 9525,
	"sprites/category/politics-and-society.svg": 17160,
	"sprites/category/productivity-and-time-management.svg": 82762,
	"sprites/category/psychology.svg": 11697,
	"sprites/category/relationships-and-parenting.svg": 96622,
	"sprites/category/religion-and-spirituality.svg": 7970,
	"sprites/category/science.svg": 75407,
	"sprites/category/society-and-culture.svg": 53960,
	"sprites/category/technology-and-the-future.svg": 54843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17743;